import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-scroll";
import { FiArrowUp } from "react-icons/fi";
import "./Footer.css";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Top */}
        <div className="footer-top">
          {/* Brand */}
          <div className="footer-brand">
            <Link to="home" smooth duration={800} className="footer-logo">
              Diana<span className="teal">.</span>
            </Link>
            <p className="footer-tagline">
              Frontend Developer crafting digital experiences with modern
              technologies.
            </p>
          </div>

          {/* Back to Top */}
          <motion.div whileHover={{ y: -5 }} className="footer-top-btn">
            <Link to="home" smooth duration={800} className="back-top">
              <FiArrowUp />
              <span>Back to Top</span>
            </Link>
          </motion.div>
        </div>

        {/* Divider */}
        <div className="footer-divider" />

        {/* Bottom */}
        <div className="footer-bottom">
          <span>© {year} Diana Gafita. All rights reserved.</span>
          <span>Crafted with precision in Romania</span>
        </div>
      </div>

      {/* Large Background Name */}
      <div className="footer-bg">DIANA</div>
    </footer>
  );
};

export default Footer;
